import { useTranslation } from 'react-i18next';

import { MenuItem } from '@/components/MenuItem/MenuItem';
import useSidebarMenu from '@/components/SidebarMenu/useSidebarMenu';
import joinClassNames from '@/utils/functions/joinClassNames/joinClassNames';

import styles from './styles.module.css';

interface SidebarNavProps {
  /** Called after a navigation item is activated. Mobile passes the drawer close, desktop passes nothing. */
  onNavigate?: () => void;
}

const SidebarNav = ({ onNavigate }: SidebarNavProps) => {
  const { t } = useTranslation();
  const { menuItems, isMenuItemEnabled } = useSidebarMenu();

  return (
    <ul className={joinClassNames(styles.sidebarNav, styles.sidebarNavScrollable)}>
      {menuItems.map((menu) => (
        <li
          key={menu.title}
          className={joinClassNames(styles.liMenuitem, menu.groupStart && styles.liMenuitemGroupStart)}
        >
          {isMenuItemEnabled(menu) ? (
            <MenuItem
              title={menu.title}
              path={menu.path}
              icon={menu.icon}
              tracking={menu.tracking}
              onClick={() => onNavigate?.()}
            />
          ) : (
            <span className={styles.menuItemDisabled} aria-disabled="true">
              <i className={`totem-icon totem-icon-${menu.icon}`} />
              <span className={styles.titleItem}>{t(menu.title)}</span>
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default SidebarNav;
